<template>
  <f-dashboard-fullscreen-layout>
    <template #sidebar-header>
      <router-link 
        v-if="previousRoute"
        :to="previousRoute"
        @click.prevent="goBack"
      >
        <i class="uil uil-angle-left"></i> Fermer
      </router-link>
    </template>

    <template #sidebar-title>
      Ajouter un code
    </template>

    <template #content-header>
      Informations

      <i class="uil uil-angle-right"></i> 
         
      Association
    </template>

    <template #content>
      <div class="max-width-500 is-margin-auto">
        <router-view 
          v-if="code"
          :id="codeId"
        ></router-view>
      </div>
    </template>

    <template #content-footer>
      <f-button
        class="is-full"
        @click="createCode"
        fill 
      >
        Créer le code
      </f-button>
    </template>
  </f-dashboard-fullscreen-layout>
</template>

<script>
  import { computed, nextTick } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'

  export default {
    async setup () {
      const { get, create, remove } = useStore('@freebe/codes')

      const codeId = computed(() => router.currentRoute.value.params.id)
      const code = computed(() => get(codeId.value))

      if (!codeId.value || !code.value) {
        const temporaryCode = await create({
          name: '',
          code: '',
          from: '',
          contact: '',
          amount: '',
          validity: undefined,
          type: '',
          roles: ['users'],
          partner_id: undefined,
        }, { local: true })

        router.push({
          name: 'code-infos',
          params: {
            id: temporaryCode._id,
          }
        })
      }

      const previousRoute = {
        name: 'codes-list',
      }

      function goBack () {
        router.push({
          name: 'codes-list'
        })

        remove(codeId.value, { local: true })
      }

      async function createCode() {
        const data = {
          name: code.value.name,
          code: code.value.code,
          from: code.value.from,
          contact: code.value.contact,
          validity: code.value.validity,
          amount: parseInt(code.value.amount, 10),
          type: code.value.type,
          roles: code.value.roles
        }

        try {
          const newCode = await create(data)
          
          console.log('CREATE', newCode)

          nextTick(goBack)
        } catch (error) {
          console.log('ERROR', error)
        }
      }

      return {
        codeId,
        code,
        previousRoute,
        goBack,
        createCode,
      }
    } 
  }
</script>